import React, {useMemo, useState} from 'react';
import Slider from 'react-slick';
import clsx from 'clsx';

import {Typography} from '@nur-portal/ui-kit';

import {GOLOS_NARODA_WIDGET_SLIDE_COUNT, GOLOS_NARODA_WIDGET_TYPES} from './constants';
import {getIsRightDirection, getPrevious, getSlidesCount, isDesktop, isMobile} from './helpers';
import {useGolosNarodaWidgetData} from './use-golos-naroda-widget-data';
import WidgetCard from './widget-card';

import '../../../../css/components/slick-styles.css';
import styles from './golos-naroda.module.css';

const GolosNarodaWidget = ({
  widgetType = GOLOS_NARODA_WIDGET_TYPES.DEFAULT,
  slideCount = 4
}) => {
  const initialActiveSlides = getSlidesCount() === GOLOS_NARODA_WIDGET_SLIDE_COUNT.SMALL ? [0] : [slideCount - 1, 0];
  const [activeIndexes, setActiveIndexes] = useState(initialActiveSlides);
  const nominations = useGolosNarodaWidgetData();
  const lastIndex = useMemo(() => {
    if (nominations.length) {
      return nominations.length - 1;
    }

    return 0;
  }, [nominations]);
  const sliderSettings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    autoplay: true,
    slidesToShow: getSlidesCount(),
    centerPadding: '15px',
    easing: 'ease-in-out',
    speed: 500,
    autoplaySpeed: 7000,
    arrows: false,
    swipeToSlide: true,
    beforeChange: (current, next) => {
      const isRightDirection = getIsRightDirection(current, next);

      if (!isMobile) {
        setActiveIndexes(isRightDirection
          ? [current, next]
          : [getPrevious(next, lastIndex), getPrevious(current, lastIndex)]
        );
      } else {
        setActiveIndexes(isRightDirection
          ? [next]
          : [getPrevious(current, lastIndex)]
        );
      }
    }
  };

  const renderCards = () => {
    if (widgetType === GOLOS_NARODA_WIDGET_TYPES.STATIC && isDesktop()) {
      return (
        <div className={styles.staticSlider}>
          {nominations.map(nomination => <WidgetCard {...nomination} isActive key={nomination._id} isStatic />)}
        </div>
      );
    }

    return (
      <Slider {...sliderSettings}>
        {nominations?.map((nomination, index) => nomination.slug && (
          <WidgetCard
            {...nomination}
            key={nomination.slug}
            isActive={activeIndexes.includes(index)}
          />
        ))}
      </Slider>
    );
  };

  return (
    <div className={clsx(styles.container, styles[widgetType])}>
      <Typography variant='title-21' className={styles.title}>
        Голос народа-2024
      </Typography>
      <Typography variant='text-14' className={styles.description}>
        Оцени работу политика
      </Typography>
      {renderCards()}
    </div>
  );
};

export {GolosNarodaWidget};
